var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('span',[_vm._v("0"+_vm._s(_vm.index + 1))]),_c('h3',[_c('router-link',{attrs:{"to":_vm.url}},[_vm._v(_vm._s(_vm.title))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }